<template>
    <div v-if="hiddenItems.length > 0" class="more-links">
        <div class="section-title">{{ $t('common.more') }}</div>
        <div class="more-grid">
            <button v-for="item in hiddenItems" :key="item.ref" type="button" class="more-card"
                @click="pushRoute(item.link)">
                <span class="more-icon">
                    <v-icon size="20">{{ item.icon }}</v-icon>
                </span>
                <span class="more-title">{{ item.title }}</span>
                <v-icon size="16" class="more-chevron">mdi-chevron-right</v-icon>
            </button>
        </div>
    </div>
</template>

<script>
import { links } from "@/mixins/baseGlobalMixin";

// Los que la bottom nav esconde en mobile por falta de lugar. Salen de la misma
// config que la barra, asi que respetan el filtro por plan sin duplicarlo.
const HIDDEN_REFS = ['business', 'evaluations']

export default {
    name: "MoreLinks",
    mixins: [links],
    computed: {
        hiddenItems(vm = this) {
            return vm.currentItems.filter(item => {
                if (!HIDDEN_REFS.includes(item.ref) || !item.link) return false
                return !(vm.isFreePlan && item.ref === 'evaluations')
            })
        },
    },
}
</script>

<style scoped>
.more-links {
    margin-top: 24px;
}

.section-title {
    font-size: var(--fs-label);
    font-weight: 700;
    text-transform: capitalize;
    color: var(--v-txtPrimary-base);
    margin-bottom: 10px;
}

.more-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}

.more-card {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 12px;
    border-radius: 14px;
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    text-align: left;
    min-width: 0;
    transition: border-color 0.15s;
}

.more-card:hover {
    border-color: var(--v-outline2-base);
}

.more-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    flex-shrink: 0;
    border-radius: 10px;
    background: rgba(51, 153, 153, 0.12);
}

.more-icon .v-icon {
    color: var(--v-secondary-base);
}

.more-title {
    flex: 1 1 auto;
    min-width: 0;
    font-size: var(--fs-label);
    font-weight: 600;
    color: var(--v-txtPrimary-base);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.more-chevron {
    flex-shrink: 0;
    color: var(--v-txtMuted-base) !important;
}

@media (max-width: 400px) {
    .more-grid {
        grid-template-columns: 1fr;
    }
}
</style>
